
export class Config {

    static organizationId = '67eab8a369ffab0df0ca4fee';
    static organizationName = "@mod-appname";
    static appVersion = '2.00.06';

    static cipher: string = 'KPdzpXFGaUkAFHwj5FBy82B6'; 

    static isCanuucan = 'false';

    static pickupTypes = [ 'DELIVERYTYPE02', 'DELIVERYTYPE07' ];

    constructor() { }
}
